import { Alert } from 'antd';
import { useCallback } from 'react';
import { gold } from '@ant-design/colors';
import { StarFilled } from '@ant-design/icons';
import { useLocaleStore } from '@/store';
import { useSelfContext } from '@/context';
import { useTranslation } from 'react-i18next';
import { Flex, IcArrow, LoadingSpin } from '@/components/common';

import './styles.css';

export interface SelfListProps {
  onSelect?: (self: SelfEntity) => void;
}

export function SelfList({ onSelect }: SelfListProps) {

  const [t] = useTranslation(['common']);
  const dir = useLocaleStore(state => state.dir);
  const { loading, error, selfText, selectSelf, currentSelfItems } = useSelfContext();

  const onSelfClick = useCallback((self: SelfEntity) => {
    const clone = { ...self };
    selectSelf(clone);
    if (onSelect) {
      onSelect(clone);
    }
  }, [selectSelf, onSelect]);

  if (loading) {
    return (
      <Flex className="min-h-[200px]" align="center" justify="center">
        <LoadingSpin />
      </Flex>
    );
  }

  return (
    <Flex className="app-self-list min-h-[200px]" direction="column">
      {currentSelfItems.length === 0 && (
        error ?
          <Alert type="error" message={`${t('common:errors.fetch-data')}: ${error}`} /> :
          <Alert type="warning" message={selfText('no-self')} />
      )}
      {currentSelfItems.map((item, i) => (
        <Flex
          key={i}
          align="center"
          direction="row"
          className="self-list-item"
          onClick={() => onSelfClick(item)}
        >
          <span>{item.name}</span>
          <Flex inlineFlex className="ms-auto" align="center" justify="center">
            {!!item.freeRestaurant && (
              <StarFilled style={{ color: gold.primary }} />
            )}
            <IcArrow type={dir === 'rtl' ? 'left' : 'right'} />
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
}

export default SelfList;
